/**
 *
 * Header Anchors
 *
 * Adds an anchor tag to the H2 and H3 elements based on the element passed in
 */

const $         = require( 'jQuery' );
const _model    = require( './utilities/_model.js' );


var HeaderAnchors = function(el){

    //setup some variables
    this.$el        = $(el);
    this.$headers   = this.$el.find( 'h2, h3' );
    this.headerSlugs= [];
    this.urlHash    = window.location.hash;
    this.url        = window.location.href;
    this.$sticky    = $(document).find( '#sticky-nav' );
    //default scroll settings - note tho -- we need to calculate the height of the sticky menu each time smooth scroll runs
    this.scrollSettings = {
        threshold           : 50,
        offset              : 110,
        animationDuration   : 550
    };
    this.additionalOffset = 20;

    this.init();

};

HeaderAnchors.prototype.init = function(){

    //events
    $(document).on( 'click', '.itbl-c-anchor-hash__link', this.event__handleAnchorScroll.bind(this) );

    this.cancelHashInit();
    this.createAnchors();

};

HeaderAnchors.prototype.init__scrollOnLoad = function(){


    if( this.urlHash && this.headerSlugs.includes( this.urlHash.substring(1) ) ){

        //calculate sticky height again
        this.scrollSettings.offset = this.$sticky.outerHeight() + this.additionalOffset;

        // //smooth scroll to the stop of the hash, which has the same ID as the hash
        setTimeout( ()=>{
            $(`a[href=${this.urlHash}]`).trigger( 'click' );
        }, 500 );



    }

};

HeaderAnchors.prototype.cancelHashInit = function(){

    if ( this.urlHash ) {
        setTimeout(function() {

            window.scrollTo(0, 0);

        }, 1);
    }
};

//event to handle clicking on the anchor
HeaderAnchors.prototype.event__handleAnchorScroll = function(event){

    let target                  = $(event.currentTarget);
    //calculate sticky height again
    this.scrollSettings.offset  = this.$sticky.outerHeight() + this.additionalOffset;

    //smooth scroll to the stop of the hash, which has the same ID as the hash
    Foundation.SmoothScroll.scrollToLoc( target, this.scrollSettings );

};

//iterate through the headers and add an anchor link icon
//also creates an array of headers to check against the initial load scroll event
HeaderAnchors.prototype.createAnchors = function(){

    this.$headers.each( ( index, val )=>{

        const heading       = $(val);
        const headingText   = heading
            .text()
            .toLowerCase()
            .trim()
            .replace( /[^\w\s-]/gi, '' )
            .replace(/ +/g,'-');

        if( ! _model.empty( headingText ) ){
            this.headerSlugs.push( headingText );
        }

        /************
         *
         * Leaving out the link icon for now, but leaving the code here for future use
         */
        let hashIcon = $('<span />')
            .attr({
                'aria-hidden'  : 'true',
                'class'        :'fas fa-link itbl-c-anchor-hash__icon'
            });

        heading
            .addClass( 'itbl-c-anchor-hash' )
            .wrapInner( `<a href="#${headingText}" class="itbl-c-anchor-hash__link"></a>` );


    } );

};


$(document).ready(function(){

    //check to see if anchor hashes are enabled for this post
    if( !ITBL.enable_hash || ITBL.excluded_hash_post  ){
        return false;
    }

    $(".page-template-default:not(.home) > .site-content, .single-post > .site-content").each(function(){

        //let's initialize the function, which sets up variables on document load
        const anchors = new HeaderAnchors(this);

        //using the same instance, here we do the initial scroll to anchor on page load
        $(window).load(function() {

            anchors.init__scrollOnLoad();

        });

    });

});



